import { IUserDto } from "../../interfaces/user/IUserDto";
import { cryptoPortfolioService } from "../httpService/cryptoPorfolio.service";

export async function tryGetUserLoggedIn() {
    return await cryptoPortfolioService.get<IUserDto>('/user/getuserloggedin');
}

export async function tryUpdateUser(user: IUserDto) {
    return await cryptoPortfolioService.put('/user/updateuser', user);
}